import axios from "axios";
import { useCallback } from "react";
import { useQuery } from "@tanstack/react-query";
import { useAuth } from "@clerk/react";

export const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND}/api`;
export const http = axios.create({ baseURL: API });

export const img = (u) => (u && u.startsWith("/api") ? BACKEND + u : u);
export const inr = (n) => "₹" + Number(n || 0).toLocaleString("en-IN", { maximumFractionDigits: 0 });
export const offPct = (p) => (p.sale_price ? Math.round((1 - p.sale_price / p.price) * 100) : 0);
export const errMsg = (e) => {
  const d = e?.response?.data?.detail;
  if (Array.isArray(d)) return d.map((x) => `${x.loc?.slice(-1)[0]}: ${x.msg.replace("Value error, ", "")}`).join(" · ");
  return d || e?.message || "Something went wrong";
};

export function useGet(url, opts = {}) {
  return useQuery({ queryKey: [url], queryFn: () => http.get(url).then((r) => r.data), enabled: !!url, ...opts });
}

export function useAuthedHttp() {
  const { getToken } = useAuth();
  return useCallback(async (method, url, data, config = {}) => {
    const token = await getToken();
    const r = await http({ method, url, data, ...config, headers: { ...(config.headers || {}), Authorization: `Bearer ${token}` } });
    return r.data;
  }, [getToken]);
}

export function useAuthedGet(url, opts = {}) {
  const call = useAuthedHttp();
  const { isSignedIn } = useAuth();
  return useQuery({ queryKey: ["authed", url], queryFn: () => call("get", url), enabled: !!isSignedIn && !!url, ...opts });
}

export const waLink = (num, text) => `https://wa.me/${(num || "919214356156").replace(/\D/g, "")}?text=${encodeURIComponent(text || "Hi DEN & THREADS!")}`;
